export default "__VITE_ASSET__Bzvj3Z2e__"